export default "__VITE_ASSET__dca559f3__"